import type { SVGProps } from "react";

export const HealIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      d="M7.4364 7.08341L13.5614 12.9167M9.18641 17.0834L17.9364 8.75008C18.3453 8.36848 18.6706 7.91346 18.8937 7.41135C19.1168 6.90924 19.2331 6.36999 19.236 5.82479C19.2389 5.27959 19.1283 4.73925 18.9106 4.23501C18.6928 3.73078 18.3723 3.27266 17.9675 2.88714C17.5627 2.50162 17.0817 2.19635 16.5522 1.98898C16.0228 1.78161 15.4554 1.67625 14.883 1.67901C14.3105 1.68176 13.7443 1.79257 13.2171 2.00502C12.6899 2.21747 12.2121 2.52736 11.8114 2.91675L3.0614 11.2501C2.65254 11.6317 2.32716 12.0867 2.10409 12.5888C1.88101 13.0909 1.76467 13.6302 1.76177 14.1754C1.75888 14.7206 1.8695 15.2609 2.08724 15.7652C2.30498 16.2694 2.62552 16.7275 3.03031 17.113C3.43511 17.4986 3.91614 17.8038 4.44558 18.0112C4.97503 18.2186 5.54238 18.3239 6.11484 18.3212C6.68731 18.3184 7.25352 18.2076 7.78073 17.9951C8.30795 17.7827 8.78572 17.4728 9.18641 17.0834Z"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
